import MaxBy from 'lodash/maxBy'
import {
  getRootTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'

const __rootT = getRootTranslator()
const __rootTc = getRootPluaralTranslator()

export function getAvailableColumnsForTable(customFields, disallowedColumns) {
  const defaultColumns = [
    {
      name: __rootT('subject'),
      key: 'subject',
      default: true,
      minWidth: '250px',
      width: '300px',
      disabled: true,
      order: 1,
    },
    {
      name: __rootTc('created_by'),
      key: 'createdBy',
      default: true,
      minWidth: '100px',
      width: '220px',
      order: 2,
    },
    // {
    //   name: __rootT('status'),
    //   key: 'statusId',
    //   default: true,
    //   width: '160px',
    //   // minWidth: '100px',
    //   order: 3,
    // },
    {
      name: __rootTc('created_date'),
      key: 'createdAt',
      default: true,
      order: 3,
      minWidth: '100px',
      width: '150px',
    },
    {
      name: __rootTc('last_resolved_time'),
      key: 'lastResolvedTime',
      default: false,
      order: 4,
      minWidth: '100px',
      width: '220px',
    },
    {
      name: __rootTc('last_closed_time'),
      key: 'lastClosedTime',
      default: false,
      order: 5,
      minWidth: '100px',
      width: '220px',
    },
    ...((disallowedColumns || []).indexOf('approvalStatus') === -1
      ? [
          {
            name: `${__rootTc('approval')} ${__rootTc('status')}`,
            key: 'approvalStatus',
            default: false,
            order: 6,
            minWidth: '100px',
            width: '220px',
          },
        ]
      : []),
  ]
  let lastKnownOrder = MaxBy(defaultColumns, (i) => i.order) + 1
  const customFieldColumns = customFields.map((c) => {
    return {
      name: c.title,
      key: c.type === 'SystemFieldRest' ? c.paramName : `${c.id}`,
      // default:
      //   ['subject', 'statusId', 'templateId', 'fileAttachments'].indexOf(
      //     c.paramName
      //   ) >= 0,
      // disabled:
      //   ['subject', 'statusId', 'templateId', 'fileAttachments'].indexOf(
      //     c.paramName
      //   ) >= 0,
      default: false,
      fieldType: c.inputType,
      order: lastKnownOrder++,
      field: c,
      ...(c.type === 'datetime'
        ? {
            minWidth: '100px',
            width: '220px',
          }
        : {
            minWidth: '100px',
            width: '150px',
          }),
      ...(c.type === 'dependent' ? { tree: c.tree } : {}),
    }
  })
  return Object.freeze(defaultColumns.concat(customFieldColumns))
}
